// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G849K","importantInfo":"styles_importantInfo__3weNY"};